export default __webpack_public_path__ + "static/media/Icon 6.dd049583.svg";